import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafeurlPipe } from './safeurl.pipe';
import { SanitizerPipe } from './sanitizer.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SafeurlPipe,
    SanitizerPipe
  ],
  exports:[
    SafeurlPipe,
    SanitizerPipe
  ]
})
export class DirectivesModule { }
